const normalize=value=>String(value).normalize('NFD').replace(/\p{M}/gu,'').toLocaleLowerCase();
export function searchOptions(options,query){
  const term=normalize(query.trim());
  return term?options.filter(o=>normalize(`${o.label} ${o.searchText||''} ${o.value??''}`).includes(term)):options;
}
export function countryOptions(countries){
  const display=new Intl.DisplayNames(['en'],{type:'region'});
  return countries.map(c=>{let label=c.label;try{label||=display.of(c.name);}catch{}return {value:c.name,label:label||c.name,searchText:c.name};});
}
export const languageOptions=languages=>languages.map(l=>({value:l.name,label:l.name,searchText:l.iso_639||''}));
